/**
 * @generated SignedSource<<088ea515687102d57c51df2ade306651>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type HotelImportStatus = "COMPLETE" | "PENDING" | "SKIPPED";
import { FragmentRefs } from "relay-runtime";
export type HotelImportStatus_hotelImport$data = {
  readonly status: HotelImportStatus;
  readonly " $fragmentType": "HotelImportStatus_hotelImport";
};
export type HotelImportStatus_hotelImport$key = {
  readonly " $data"?: HotelImportStatus_hotelImport$data;
  readonly " $fragmentSpreads": FragmentRefs<"HotelImportStatus_hotelImport">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HotelImportStatus_hotelImport",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "HotelImport",
  "abstractKey": null
};

(node as any).hash = "e82ff353d9f1ade2b8b1e8041a935dff";

export default node;
